import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const setDateFormat: YJSChangeHandler<
  DatabaseChangeType.SET_DATE_FIELD_DATE_FORMAT
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.dateFormat = change.dateFormat;
  });
};
